import { useParams } from "react-router-dom";
import CustomForm from '../../../core/components/core/Util/Form/CustomForm/CustomForm';
import CustomFormContainer from '../../../core/components/core/Util/Form/CustomForm/CustomFormContainer';
import config from '../../config/config';
import Fetch from '../../../core/util/core/Fetch';
import { useEffect, useState } from 'react';

function Form() {
    const { id } = useParams();
    const [form, setForm] = useState();
    const [formContent, setFormContent] = useState(<>Carregando...</>);

    const endpointBackend = config.endpoints.backend;

    const paths = {
        endpointSave: `${endpointBackend}gci/payment-methods/save`,
        endpointGetById: `${endpointBackend}gci/payment-methods/getById`,
        urlGoBack: `/gci/payment-methods/list`,
        pathView: `/gci/payment-methods/view`
    }

    const labels = {
        labelTitleAdd: "Nova Forma de Pagamento",
        labelTitleEdit: "Editar Forma de Pagamento",
        labelTitleView: 'Visualizar Forma de Pagamento'
    }

    const getForm = (values) => {

        let form = {
            fields: [
                {
                    name: 'name',
                    type: 'text',
                    label: 'Forma de Pagamento',
                    validations: {
                        required: true
                    },
                    columnSize: 12
                },
                {
                    name: 'type',
                    type: 'select',
                    label: 'Aplicável a',
                    validations: {
                        required: true
                    },
                    columnSize: 12,
                    options: [
                        { value: 'both', label: 'Receitas e Despesas' },
                        { value: 'revenues', label: 'Somente Receitas' },
                        { value: 'expenses', label: 'Somente Despesas' },
                    ]
                }
            ],
            ...paths,
            ...labels,
        }
        form.values = values;
        return form;
    }

    useEffect(() => {
        const load = async () => {
            let values = {};
            if (id) {
                values = await Fetch.post(paths.endpointGetById, { id: id })
            }

            const form = getForm(values);

            setForm(form);
            setFormContent(
                <CustomFormContainer
                    form={form}
                    content={<CustomForm form={form} />} />
            );
        }
        load();
    }, [])

    return (
        <div>
            {formContent}
        </div>
    );
}
export default Form;
